import { useMemo } from 'react';

import {
	classNames,
} from '@common';

function useClassNames(...classes: string[]): string {
	return useMemo(() => classNames(...classes), [classes]);
}

export {useClassNames};